<template>
  <div>

    <v-row 
    v-if="editable"
    class="pa-2 pl-4 border-b--thin">

      <transition
      name="slide-x-reverse-transition"
      mode="out-in">

        <!-- ITEMS -->
        <div 
        v-if="selectedCount === 0"
        key="1"
        class="c-flex-r align-center subheading">

          <!-- select menu -->
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-check-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
              @click="selectAll">
                <v-list-item-title>Select all</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectPage">
                <v-list-item-title>Select page</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectNone">
                <v-list-item-title>Select none</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
          text
          outlined
          class="mr-2"
          @click="addItem">
            <v-icon>add</v-icon>
            <div class="ml-1 text--text">
              Add item
            </div>
          </v-btn>

        </div>

        <!-- selected count -->
        <div v-if="selectedCount > 0"
        key="2"
        class="c-flex-r align-center subheading">
          <v-btn
          icon
          class=""
          @click="selected = {}">
            <v-icon color="color1">close</v-icon>
          </v-btn>
          <div class="text-sans font-weight-bold">
            <span>&nbsp;{{ selectedCount }}</span>
            selected 
          </div>
          <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
          <span class="icon--text ml-2">|</span>
          <v-btn 
          icon
          @click="onDelete">
            <v-icon>delete_outline</v-icon>
          </v-btn>
          <!-- select menu -->
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-check-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
              @click="selectAll">
                <v-list-item-title>Select all</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectPage">
                <v-list-item-title>Select page</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectNone">
                <v-list-item-title>Select none</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

      </transition>

    </v-row>

    
    <table class="final-table caption th-no-padding lines-b pointer hover full-width">
      <colgroup ref="colgroup1">
        <col width="15px">
        <col width="15px">
        <col width="15px">
      </colgroup>

      <tr class="unselectable">

        <c-table-header
        title="Name"
        code="name"
        class="sticky"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        :title="!editable ? `x${quantityN}` : ''"
        code="empty"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Percent used"
        code="percent_used"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

      </tr>
      <tr class="disable-hover">
        <td>
          <v-text-field
          v-model="filters.search.name"
          placeholder="Search..."
          hide-details
          class="crx-box-input"
          clearable
          color="color1"
          solo>
          </v-text-field>
        </td>
        <td>

        </td>
        <td>

        </td>
        
      </tr>
      <recipe-row
      v-for="item in paginatedArray" 
      :key="item.id"
      :item="item"
      :editable="editable"
      :quantity="formData.quantity"
      :buildMaterialsTimesN="buildMaterialsTimesN"
      :totalInStock="( totalInventoryMap[item.definition.id] || {}).total || 0"
      :difference="differenceMap[item.definition.id]"
      :maxQuantity="maxQuantityDict[item.definition.id]"
      :percentDict="percentDict"
      :debitMap="debitMap"
      :remainMap="remainMap"
      :inventoryView="inventoryView"
      :debitMapTallied="debitMapTallied"
      :searchFilters="filters.search"
      :selected="selected"
      @checkRow="checkRow(item)"
      @click.native="clickRow(item)"
      ></recipe-row> 

    </table>

    <!-- NO ITEMS -->
    <div v-if="items.length === 0" class="pa-4">
      No items
    </div>
    <!-- NO ITEMS -->

    <!-- PAGINATION -->
    <c-pagination-client
    :page="page"
    :paginationLength="paginationLength"
    :paginatedArray="paginatedArray"
    :rowsPerPage.sync="rowsPerPage"
    @updatePageNumber="updatePageNumber"
    @goToFirstPage="goToFirstPage"
    @goToPreviousPage="goToPreviousPage"
    @goToNextPage="goToNextPage"
    @goToLastPage="goToLastPage">
    </c-pagination-client>
    <!-- PAGINATION -->

    <!-- DIALOGS -->
    <c-select-inv-def-dialog ref="selectItemDialog" :exceptions="exceptions">
    </c-select-inv-def-dialog>

  </div>
</template>

<script>
import Vue from 'vue'
import CTableHeader from '@/components/list-server/th'
import ListController from '@/mixins/ListController'
import RecipeRow from './components/recipe-table-row'
import JsonViewer from '@/components/toolbox/json-viewer/Main'

export default {
  props: ['itemsSource', 'editable', 'formData', 'quantityN', 'buildMaterialsTimesN', 'totalInventoryMap', 'inventoryView', 'maxQuantityDict', 'debitMap', 'remainMap', 'debitMapTallied', 'percentDict'],
  components: {
    RecipeRow,
    CTableHeader,
    JsonViewer
  },
  mixins: [ListController],
  data () {
    return {
      filters: {
        sortCol: 'percent_used',
        sortAscending: false,
        search: {
          name: ''
        }
      }
    }
  },
  computed: {
    exceptions () {
      return Object.keys(this.itemsSource).map(item => parseInt(item))
    },
    differenceMap () {
      var map = {}
      Object.keys(this.buildMaterialsTimesN).map((key, index) => {
        map[key] = (this.totalInventoryMap[key] || {}).total - this.buildMaterialsTimesN[key]
      })
      return map
    }
  },
  watch: {
    itemsSource (nv) {
      this.items = Object.values(nv)
    },
    /* rawMaterialMap () {
      var map ={}
      this.items.forEach(item => {
        if (!map[item.inventory_item_id]) {
          map[item.inventory_item_id] = {
            definition: item.definition,
            // items: [item]
            }
        } else {
          // map[item.inventory_item_id].items.push(item)
        }
      })
      return Object.values(map)
    }, */
  },
  methods: {
    onDelete () {
      var selectedRows = this.getSelectedRows()
      var idArray = selectedRows.reduce((a, i) => {
        a.push(i.definition.id)
        return a
      }, [])
      var title = 'Delete ' + idArray.length + ' item' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          this.$emit('deleteItems', idArray)
          /* for (var i = this.items.length - 1; i >= 0; --i) {
            if (idArray.includes(this.items[i].tempID)) {
              this.items.splice(i, 1)
            }
          }
          this.onSuccessfullDelete() */
        }
      })
    },
    search (items) {
      if ((this.filters.search.name || '').length > 0) {
        var keywords = (this.filters.search.name || '').toLowerCase().split(' ')
        items = items.filter(item => {
          return keywords.every(keyword => {
            return (item.definition.name.toLowerCase()).indexOf(keyword) > -1
          })
        })
      }
      return items
    },
    sort (items) {
      if (this.filters.sortCol === 'percent_used') {
        return items.sort((a, b) => {
          var aUnexpired = ( this.totalInventoryMap[a.definition.id] || {}).unexpired
          var bUnexpired = ( this.totalInventoryMap[b.definition.id] || {}).unexpired
          if (!aUnexpired && bUnexpired) {
            return this.filters.sortAscending ? 1 : -1
          } else if (!bUnexpired && aUnexpired) {
            return this.filters.sortAscending ? -1 : 1
          } else if (!aUnexpired && !bUnexpired) {
            return 0
          }
          return this.filters.sortAscending ? this.percentDict[a.definition.id] - this.percentDict[b.definition.id] : this.percentDict[b.definition.id] - this.percentDict[a.definition.id]
        })
      } else if (this.filters.sortCol === 'name') {
        return items.sort((a, b) => {
          return this.filters.sortAscending ? a.definition.name.localeCompare(b.definition.name) : b.definition.name.localeCompare(a.definition.name)
        })
      } /* else if (headerIndex === 2) { // Date of entry
        return items.sort((a, b) => {
          return sortAscending ? new Date(b.date_of_entry) - new Date(a.date_of_entry) : new Date(a.date_of_entry) - new Date(b.date_of_entry)
        })
      } else if (headerIndex === 3) { // Expiry
        return items.sort((a, b) => {
          return sortAscending ? new Date(b.expiry_date) - new Date(a.expiry_date) : new Date(a.expiry_date) - new Date(b.expiry_date)
        })
      } else if (headerIndex === 4) { // Supplier
        return items.sort((a, b) => {
          var supplierA = (this.$store.state.db.suppliers.suppliers[a.supplier_id] || {}).name || ''
          var supplierB = (this.$store.state.db.suppliers.suppliers[b.supplier_id] || {}).name || ''
          return sortAscending ? supplierA.localeCompare(supplierB) : supplierB.localeCompare(supplierA)
        })
      } */
    },
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        this.$emit('onOpenInventoryNav', item)
      }
    },
    addItem () {
      this.$refs.selectItemDialog.open()
        .then((selectedItem) => {
          this.$emit('addItem', selectedItem)
        })
        .catch(() => {
          // console.log('rejected')
        })
    }
  },
  created () {
    this.items = Object.values(this.itemsSource)
  }
}
</script>